import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {SettingsService} from 'src/app/services/settings.service';
import {AppState} from 'src/app/store/reducers';
import {AddDesignationComponent} from '../add-designation/add-designation.component';
import {Designation} from 'src/app/store/entities/instution-settings/designation/designation.model';
import {Institution} from 'src/app/store/entities/system-settings/institution/institution.model';
import {StorageService} from 'src/app/services/storage.service';
import {selectStoreItems} from "../../../../store/entities/store-item/store-item.selectors";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {
  DELETE_DESIGNATION,
  GET_INSTUTIONS_DESIGNATION
} from "../../../../store/entities/instution-settings/designation/designation.graphql";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";

@Component({
  selector: 'app-designation-list',
  templateUrl: './designation-list.component.html',
  styleUrls: ['./designation-list.component.scss']
})
export class DesignationListComponent implements OnInit {


  title: string;
  tableColumns: object;
  tableData: Observable<Designation[]>;
  institution: Institution;

  designationsNew$: Observable<Designation[]>;

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private storageService: StorageService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.title = 'Designation';

    this.institution = this.storageService.getItem('institution');

    this.designationsNew$ = this.store.select(selectStoreItems(StoreItemEntity.institutionDesignation))
    this.store.dispatch(StoreItemActions.getStoreItems({
      entity: StoreItemEntity.institutionDesignation,
      query: GET_INSTUTIONS_DESIGNATION,
      isNotFiltering: true,
      filtering: {institutionUniqueId: this.institution?.institutionUniqueId}
    }))


    this.tableColumns = {
      no: 'SN',
      designationName: 'Name',
      designationShortForm:  'Short Form',
      actions: 'Actions'
    }

    this.tableData = this.store.select(selectStoreItems(StoreItemEntity.institutionDesignation))
  }


  addEditDesignation(designation: Designation = null): void {
    this.settingsService.openDialogModal({
      component: AddDesignationComponent,
      width: '50%',
      data: designation
    })
  }

  deleteDesignation(designation: Designation): void {
    const message = 'Are you sure?';
      this.notificationService.confirmation(message, 'Delete').then((data) => {
        if(data.value){
          this.store.dispatch(StoreItemActions.removeStoreItem({
            entity: StoreItemEntity.institutionDesignation,
            id: designation?.id,
            input: {
              designationUniqueId: designation.designationUniqueId
            },
            mutation: DELETE_DESIGNATION
          }))
        }
      })
  }


}
